<fcom-modal
  [(open)]="isOpen"
  [title]="'MMB.view.changeFlightsModal.generalInfoTitle' | finLocalization"
  [fitToContent]="true"
  [fullHeight]="true"
  [buttons]="ModalButtons.CUSTOM"
  (close)="closeModal()"
  [overlayClickable]="false"
>
  <div data-testid="general-info-fragment" class="pr-large">
    <cms-unstyled-fragment
      [showTitle]="true"
      [contentUrl$]="'MMB.fragments.changeBookingModalConfirm.url' | finLocalization | finToObservable"
    >
    </cms-unstyled-fragment>
  </div>
  <div buttons>
    <fcom-button
      [text]="'actions.cancel' | finLocalization"
      (clickBtn)="closeModal()"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      class="mr-xsmall-r"
      data-testid="change-flight-modal-close"
    ></fcom-button>
    <fcom-button
      *ngIf="changeFlightInfo$ | async as changeFlightInfo"
      [text]="'actions.continue' | finLocalization"
      (clickBtn)="goToNextStep(changeFlightInfo)"
      data-testid="change-flight-modal-go-to-select-bounds"
    ></fcom-button>
  </div>
</fcom-modal>
